import { Application } from "@hotwired/stimulus"
import "mapkick/bundle"
import "@tailwindplus/elements";

const application = Application.start()

import { Alert, Autosave, Dropdown, Modal, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components"
import TabsController from "./tabs_controller"
application.register('alert', Alert)
application.register('autosave', Autosave)
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', TabsController)
application.register('popover', Popover)
application.register('toggle', Toggle)
application.register('slideover', Slideover)


// Configure Stimulus development experience
application.debug = true
window.Stimulus   = application

export { application }